<script>
import {PrismEditor} from "vue-prism-editor";
import "vue-prism-editor/dist/prismeditor.min.css";
import {highlight, languages} from "prismjs/components/prism-core";
import "prismjs/components/prism-clike";
import "prismjs/components/prism-css";
import "prismjs/components/prism-markup";
import "prismjs/components/prism-javascript";
import "prismjs/themes/prism-coy.css";

export default {
  components: {
    PrismEditor,
  },
  name: "styleEditor",
  mounted: async function () {
    let storedCss = await this.$A.AccountService.GetReviewStylesheet();
    this.oldCss = storedCss && storedCss.stringValue ? storedCss.stringValue : this.defaultCss;
    this.newCss = this.oldCss;
  },
  methods: {
    highlighter(css) {
      return highlight(css, {...languages['css'], ...languages['markup'], ...languages['js']}, 'markup');
    },
    resetEditorStyle() {
      this.newCss = this.defaultCss;
      try {
        this.$A.AccountService.SaveReviewStylesheet(this.newCss);
        self.$A.AlertUser(
            "Custom Style Saved",
            "success",
            10000
        );
      } catch (err) {
        console.log("error", err);
        self.$A.AlertUser(
            "Failed to save style. Please, try again.",
            "warning",
            10000
        );
      }
    },
    onSave() {
      if (this.oldCss !== this.newCss) {
        try {
          this.$A.AccountService.SaveReviewStylesheet(this.newCss);
          this.oldCss = this.newCss;
          self.$A.AlertUser(
              "Custom Style Saved",
              "success",
              10000
          );
        } catch (err) {
          console.log("error", err);
          self.$A.AlertUser(
              "Failed to save style. Please, try again.",
              "warning",
              10000
          );
        }
      }
    },
  },
  data() {
    return {
      user: this.$A.Auth,
      oldCss: "",
      newCss: "",
      defaultCss: require('./default-style.js').default,
      lineNumbers: true,
      visibleEditor: false,
      show: false,
    }
  },

};
</script>

<template>
  <div class="settings-card">
    <div class="card-head">
      <div class="card-head-title">Custom Review Screen Styles</div>
      <div class="card-head-subtitle">Customize your review screen with your own CSS.</div>
    </div>
    <div class="card-body">
      <div class="editor-well">
        <prism-editor
            class="style-editor"
            v-model="newCss"
            :highlight="highlighter"
            :line-numbers="lineNumbers"
            data-cy="cssEditor"
        >
        </prism-editor>
      </div>
    </div>
    <div class="card-foot">
      <b-button
          id="resetStyle"
          class="secondary-btn"
          variant="secondary"
          @click="resetEditorStyle"
      >Reset</b-button>
      <b-button
          class="primary-btn"
          @click="onSave"
          data-cy="saveCssBtn"
      >Save</b-button>
    </div>
  </div>
</template>

<style scoped>
.settings-card {
  background: #fff;
  border: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(8, 11, 13, 0.04), 0 8px 24px -16px rgba(8, 11, 13, 0.1);
}
.card-head {
  padding: 14px 20px;
  background: #fbfbfc;
  border-bottom: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 12px 12px 0 0;
}
.card-head-title {
  font-size: 15px;
  font-weight: 600;
  color: #111827;
}
.card-head-subtitle {
  margin-top: 1px;
  font-size: 12.5px;
  font-weight: 400;
  color: #6b7280;
}
.card-body {
  padding: 20px;
}
.card-foot {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 20px;
  background: #fbfbfc;
  border-top: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 0 0 12px 12px;
}
.editor-well {
  border: 1px solid rgba(15, 23, 42, 0.1);
  border-radius: 8px;
  overflow: hidden;
}
.style-editor {
  background-color: #fbfbfc;
  font-style: normal;
  font-family: Fira code, Fira Mono, Consolas, Menlo, Courier, monospace;
  font-size: 13px;
  line-height: 1.5;
  font-weight: normal;
  padding: 8px 10px;
  height: 240px;
}
div > .prism-editor-wrapper >>> textarea {
  outline: none !important;
  box-shadow: none !important;
}
.primary-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  padding: 0 18px;
  background: #019256;
  color: #fff;
  border: 0;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 120ms ease;
}
.primary-btn:hover,
.primary-btn:focus,
.primary-btn:active {
  background: #017a48 !important;
  color: #fff;
}
.secondary-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  padding: 0 14px;
  background: #fff !important;
  color: #1f2937 !important;
  border: 1px solid rgba(15, 23, 42, 0.12) !important;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: border-color 120ms ease, color 120ms ease;
}
.secondary-btn:hover,
.secondary-btn:focus {
  border-color: #019256 !important;
  color: #019256 !important;
}
@media (max-width: 575px) {
  .primary-btn,
  .secondary-btn {
    flex: 1;
  }
}
</style>
